export const getUserDisplayName = (user) => {
  if (!user) return '';
  const firstName = user.first_name?.trim();
  return firstName || user.username || '';
};
